/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Cancellation_And_CommitmentInputs */

const en_admin_resources_cancellation_and_commitment = /** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation & Commitment`)
};

const de_admin_resources_cancellation_and_commitment = /** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung und Mindestlaufzeit`)
};

const es_admin_resources_cancellation_and_commitment = /** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelación y compromiso`)
};

const fr_admin_resources_cancellation_and_commitment = /** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulation et engagement`)
};

/** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */
const it_admin_resources_cancellation_and_commitment = en_admin_resources_cancellation_and_commitment;

/** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */
const pt_br2_admin_resources_cancellation_and_commitment = en_admin_resources_cancellation_and_commitment;

/** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */
const pl_admin_resources_cancellation_and_commitment = en_admin_resources_cancellation_and_commitment;

/** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */
const hu_admin_resources_cancellation_and_commitment = en_admin_resources_cancellation_and_commitment;

/** @type {(inputs: Admin_Resources_Cancellation_And_CommitmentInputs) => LocalizedString} */
const ro_admin_resources_cancellation_and_commitment = en_admin_resources_cancellation_and_commitment;

/**
* | output |
* | --- |
* | "Cancellation & Commitment" |
*
* @param {Admin_Resources_Cancellation_And_CommitmentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_cancellation_and_commitment = /** @type {((inputs?: Admin_Resources_Cancellation_And_CommitmentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Cancellation_And_CommitmentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "de") return de_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "es") return es_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "fr") return fr_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "it") return it_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "pl") return pl_admin_resources_cancellation_and_commitment(inputs)
	if (locale === "hu") return hu_admin_resources_cancellation_and_commitment(inputs)
	return ro_admin_resources_cancellation_and_commitment(inputs)
});
export { admin_resources_cancellation_and_commitment as "admin.resources.cancellation_and_commitment" }